import React from 'react';
import PropTypes from 'prop-types';
/* context */
import { ValidationContext } from './validation-form';

class ValidationButton extends React.PureComponent {
    render() {
        const errors = this.props.context.showErrors ? Object.keys(this.props.context.errors).length : 0;
        const title = `${errors > 1 ? errors : 'One'} field${errors > 1 ? 's' : ''} invalid`;

        const disabled = typeof this.props.disabled === 'boolean'
            ? this.props.context.submitDisabled || this.props.disabled
            : this.props.context.submitDisabled;

        return (
            <button
                value={this.props.value}
                type={this.props.type}
                className={`sten-validation-button${this.props.className ? ` ${this.props.className}` : ''}`}
                title={errors ? title : ''}
                disabled={disabled}
                name="button"
            >
                {this.props.children}
                {errors > 0 && (
                    <span className="sten-validation-button__badge">{errors}</span>
                )}
            </button>
        );
    }
}

ValidationButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    context: PropTypes.objectOf(PropTypes.any).isRequired,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    value: PropTypes.string
};

ValidationButton.defaultProps = {
    children: null,
    className: '',
    disabled: undefined,
    type: 'submit',
    value: ''
};

export default props => (
    <ValidationContext.Consumer>
        {context => <ValidationButton {...props} context={context} />}
    </ValidationContext.Consumer>
);
